<template>

	<div class="row">
		<div class="col-md-6 col-md-offset-3 col-sm-12">
			<h3 class="page-header">403: Permission Denied</h3>
            <div class="card">
                <div class="card-body">
                    <p>
                    You do not have permission to access this resource.
                    <button class="btn btn-sm btn-primary" v-on:click="routerBack()">
                        <i class="fa fa-caret-left"></i> Back to Last Page
                    </button>
                    </p>
                    <p v-if="!is_subcontractor">
                        If you think you are missing a role/permission, you can request roles here:
                        <router-link to="/profile/request-roles" class="btn btn-sm btn-warning">
                            <i class="fa fa-envelope"></i> Request Roles
                        </router-link>
                    </p>
                </div>
            </div>
    	</div>
    </div>
</template>

<script>
    export default {
    	data: function() {
            return {
                permissions_required: null,
            }
        },

        computed: {
            is_subcontractor(){
                //Send it
                if(this.$store.state.user.subcontractor_id != null)
                {
                    return true;
                }

                //Send it
                return false;
            }
        },

        methods: {
            routerBack(){
                this.$router.go(-2);
            },

            getRoles(){
                //Check for null
                if(!this.permissions_required)
                {
                    return;
                }

                //Send it - TO DO
            },
        },

        mounted() {
            //Check it
            if(this.$store.state.permissions_required)
            {
                //Set this
                this.permissions_required = this.$store.state.permissions_required;

                //Clear the Permissions
                this.$store.commit('setPermissionsRequired', null);
            }

            //Run it
            this.getRoles();
        }
    }
</script>
